// src/telemetry/queue/BatchUploader.ts

import { API_BASE_URL }
  from '../../services/api';

import type {
  TelemetryEvent,
} from '../types/telemetry';
import { ACTIONS } from '../constants/actions';

export class BatchUploader {

  // TODO/DEPRECATED: upload is deprecated because the backend '/batch' endpoint is deprecated. All telemetry must use '/event'.
  /*
  async upload(
    sessionId: string,
    events: TelemetryEvent[],
  ): Promise<boolean> {

    const telemetryEvents = events.filter(event => {
      const action = event.actionType || '';
      return String(event.eventType) !== 'api' &&
        action !== 'api_request' &&
        action !== 'api_success' &&
        action !== 'api_failure';
    });

    if (!telemetryEvents.length)
      return true;

    return true;
  }
  */

  async uploadEvent(
    event: TelemetryEvent,
  ): Promise<boolean> {
    console.log("uploadEvent called", event);
    const action = event.actionType || '';
    if (String(event.eventType) === 'api' ||
      action === 'api_request' ||
      action === 'api_success' ||
      action === 'api_failure') {
      return true;
    }

    try {
      const token =
        localStorage.getItem('access_token') ||
        localStorage.getItem('admin_token');

      if (!token)
        return true;

      const BACKEND_ALLOWED = new Set<string>(Object.values(ACTIONS));

      const sanitizeAction = (action?: string, eventType?: string) => {
        if (action && BACKEND_ALLOWED.has(action)) return action;

        // map common frontend-only action names to backend-accepted ones
        if (action === 'heartbeat_pulse') return 'heartbeat';
        if (action === 'tab_change') return 'page_view';
        if (action === 'form_submit') return 'create';
        if (action === 'form_open') return 'create';
        if (action === 'form_error') return 'update';
        if (action === 'cta_click') return 'create';
        if (!action && eventType === 'page_view') return 'page_view';

        // fallback mapping heuristics
        if (!action) return 'create';
        if (action.includes('publish')) return 'publish';
        if (action.includes('save') || action.includes('generate')) return 'create';
        if (action.includes('edit')) return 'update';
        if (action.includes('download')) return 'download';
        if (action.includes('export')) return 'export';

        // final fallback
        return BACKEND_ALLOWED.has(action) ? action : 'create';
      };

      const payload = {
        session_id: event.sessionId || 'unknown_session',
        module_name: event.moduleName,
        action_type: sanitizeAction(event.actionType, event.eventType),
        submodule_name: event.submoduleName,
        client_timestamp: new Date(event.timestamp).toISOString(),
        route_path: event.routePath,
        action_label: event.actionLabel,
        metadata: event.metadata || {},
        device_info: event.deviceInfo,
        browser_info: event.browserInfo,
        event_category: event.eventType,
        previous_route: event.previousRoute ?? null,
        current_route: event.routePath,
        active_duration_seconds: event.activeDurationSeconds ?? 0,
        session_duration_seconds: event.sessionDurationSeconds ?? 0,
        user_id:
          localStorage.getItem('user_id') ||
          localStorage.getItem('admin_username'),
        last_active_timestamp: new Date(event.timestamp).toISOString(),
        last_visited_module: event.moduleName,
        last_visited_submodule: event.submoduleName,
        active_session_state: event.activeSessionState ?? { state: 'active' },
        module_visit_frequencies: event.moduleVisitFrequencies ?? {},
      };

      const response = await fetch(
        `${API_BASE_URL}/telemetry/event`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token
              ? {
                Authorization: `Bearer ${token}`,
              }
              : {}),
          },
          body: JSON.stringify(payload),
          keepalive: true,
        }
      );

      if ([400, 401, 403, 422].includes(response.status)) {
        console.warn(
          '[Telemetry Event] Unprocessable or Unauthorized. Discarding event to avoid loops.',
          response.status
        );
        return true;
      }

      return response.ok;
    } catch (error) {
      console.error(
        '[Telemetry Event Error]',
        error
      );
      return false;
    }
  }

}

export const batchUploader =
  new BatchUploader();
